var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","size":"large","columns":_vm.tableHeader,"data":_vm.chapterData}}),_vm._v(" "),_c('div',{staticClass:"page-jump"},[_c('Page',{attrs:{"total":_vm.pageTotal,"show-elevator":"","page-size":_vm.pageSize},on:{"on-change":_vm.pageJump}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122a976c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeachingBorderList.vue
// module id = null
// module chunks = 